import AdminAPIService from "./AdminAPIService";

  /* 
    @param id: sub | username
  */  

export default class UsersService extends AdminAPIService {
  constructor() {
    super()
    this.userGroups = {
      admin: 'admin-group',
      team: 'team-representative',
      business: 'business-representative',
      employee: 'employee',
    }
  }

  #getUserGroup(group = null) {
    if(this.userGroups[group] == null) {
      console.error('User group doesn\'t exist')
      throw new Error('User group doesn\'t exist');
    } 

    return this.userGroups[group]
  }

  getUser(id = null) {
    return this.apiCall({
      method: this.methods.GET,
      url: `/v2/employees/${id}`,
    });
  }

  deleteUser(id = null) {
    return this.apiCall({
      method: this.methods.DELETE,
      url: `/v2/employees/${id}`,
    });
  }


  updateUser(payload = {}, id = null, ) {
      return this.apiCall({
        method: this.methods.PATCH,
        url: `/v1/employees/${id}`,
        payload,
      });
    }

  updateCognitoUser(payload = {}, id = null, ) {
    return this.apiCall({
      method: this.methods.PATCH,
      url: `/v2/employees/${id}`,
      payload,
    });
  }

  removeUserFromGroup(groupName = {}, id = null, ) {
    return this.apiCall({
      method: this.methods.DELETE,
      url: `/v1/employees/${id}/groups/${this.#getUserGroup(groupName)}`,
    });
  }

  addUserToGroup(groupName = {}, id = null, ) {
    return this.apiCall({
      method: this.methods.POST,
      url: `/v1/employees/${id}/groups/${this.#getUserGroup(groupName)}`,
    });
  }

  getUsersByGroup(groupName = {}, payload = {}) {
    return this.apiCall({
      method: this.methods.GET,
      url: `/v1/employees/groups/${this.#getUserGroup(groupName)}?per_page=60`,
      payload,
    });
  }
}

export const usersAPI = new UsersService();
